/**
 * CouponUsagesProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import CouponUsagesContext from './coupon-usages-context'
import {
  createCouponUsage,
  fetchCouponUsages,
  fetchCouponUsage,
} from './coupon-usages-api'

export default function CouponUsagesProvider({ children }) {
  const state = {
    createCouponUsage,
    fetchCouponUsages,
    fetchCouponUsage,
  }
  return (
    <CouponUsagesContext.Provider value={state}>
      {children}
    </CouponUsagesContext.Provider>
  )
}
